import React, {Component} from 'react';
import { Alert, Grid } from 'react-bootstrap';
import { ERROR_401 } from '../../../utils/messages'

class Error401 extends Component {
    render(){
        return(
            <Grid><center><Alert bsStyle="danger">{ERROR_401}</Alert></center></Grid>
        );
    }
}

export default Error401;